import View from "../../../Nav/Js/views/common/CategoryNavView";
import components from "./components.js";
components.define("js-CategoryNav", View);